/**
 * Regalplatz / Lagerort-Label (bentomax/hawk#611).
 *
 * Gleiche Regel wie `ShelfLabel.normalize` (Rails) und `normalizeShelfLabel`
 * (App): heute nur Trim + Großbuchstaben, leer ergibt `null`. Sobald das
 * Format feststeht, kommt die Regel hierher (und als CHECK in die DB).
 */
export function normalizeShelfLabel(input: string | null | undefined): string | null {
  if (typeof input !== 'string') return null

  const value = input.trim().toUpperCase()
  return value || null
}
